const configs = {

    // Standing duration at origin and destination in milliseconds
    standingDuration: 60000,

    // Minimum standing duration in milliseconds
    minStandingDuration: 30000,

    // Minimum bus standing duration in milliseconds
    minBusStandingDuration: 15000,

    // Interval of refreshing object positions in milliseconds
    refreshInterval: 60000,

    // All object positions will be refreshed if the screen has been inactive for this duration
    refreshTimeout: 10000,

    // Interval of checking train and bus positions based on real-time data in milliseconds
    realtimeCheckInterval: 15000,

    // Maximum train speed in km/h
    maxSpeedKMPH: 80,

    // Train acceleration in km/h/s
    accelerationKMPHPS: 3,

    // Maximum train speed in km/ms
    get maxSpeed() {
        return configs.maxSpeedKMPH / 3600000;
    },

    // Train acceleration in km/ms^2
    get acceleration() {
        return configs.accelerationKMPHPS / 3600000000;
    },

    // Time required to reach maximum train speed in milliseconds
    get maxAccelerationTime() {
        return configs.maxSpeed / configs.acceleration;
    },

    // Distance required to reach maximum train speed in kilometers
    get maxAccDistance() {
        return configs.maxAccelerationTime * configs.maxSpeed / 2;
    },

    // Maximum flight speed in km/h
    maxFlightSpeedKMPH: 500,

    // Flight acceleration in km/h/s
    flightAccelerationKMPHPS: 12,

    // Maximum flight speed in km/ms
    get maxFlightSpeed() {
        return configs.maxFlightSpeedKMPH / 3600000;
    },

    // Flight acceleration in km/ms^2
    get flightAcceleration() {
        return configs.flightAccelerationKMPHPS / 3600000000;
    },

    // Maximum bus speed in km/h
    maxBusSpeedKMPH: 30,

    // Bus acceleration in km/h/s
    busAccelerationKMPHPS: 3,

    // Maximum bus speed in km/ms
    get maxBusSpeed() {
        return configs.maxBusSpeedKMPH / 3600000;
    },

    // Bus acceleration in km/ms^2
    get busAcceleration() {
        return configs.busAccelerationKMPHPS / 3600000000;
    },

    // Time required to reach maximum bus speed in milliseconds
    get maxBusAccelerationTime() {
        return configs.maxBusSpeed / configs.busAcceleration;
    },

    // Distance required to reach maximum bus speed in kilometers
    get maxBusAccDistance() {
        return configs.maxBusAccelerationTime * configs.maxBusSpeed / 2;
    },

    // Delay in milliseconds for minimizing precision error
    minDelay: 25000,

    // 이 값 미만은 지연으로 보지 않는다. 마커와 설명이 같은 기준을 써야 한다 —
    // 마커는 '0 이 아니면' 으로 붙고 설명은 1분 이상일 때만 지연을 적어서, 3초짜리
    // 값에 마커만 뜨고 설명에는 아무 말이 없었다 (실측: 피드 70편성 중 31개가
    // 1분 미만, 그 중 25개가 3초).
    delayThreshold: 60000,

    // Minimum flight interval in milliseconds
    minFlightInterval: 90000,

    // Time allotted for transitions to complete
    transitionDuration: 300,

    // Fade duration when an object is added or removed
    fadeDuration: 1000,

    // Origin of coordinates (around Tokyo station)
    defaultCenter: [126.9973, 37.5216],

    // Default zoom level
    defaultZoom: 11.5,

    // Default bearing (rotation) of the map
    defaultBearing: 0,

    // Default pitch in degrees
    defaultPitch: 60,

    // Default frame rate for train and aircraft animations in the Eco mode
    defaultEcoFrameRate: 1,

    // Default view mode
    // 'both' = 지상·지하를 함께. 지하 선로가 반투명으로 같이 보인다.
    defaultViewMode: 'both',

    // Default tracking mode
    defaultTrackingMode: 'position',

    // Default clock mode
    defaultClockMode: 'realtime',

    // Default time zone (IANA name) used by the clock and as the fallback for GTFS
    // feeds that don't specify a valid agency_timezone
    defaultTimezone: 'Asia/Seoul',

    // Default eco mode
    defaultEcoMode: 'normal',

    // ODPT-compatible API hosts and the secrets key each one uses
    odptHosts: {},

    // Default data URL
    dataUrl: 'data',

    // Default data sources
    dataSources: [],

    // 경로검색 백엔드. 상류 API(search.minitokyo3d.com)는 도쿄 역 id 만 알기 때문에
    // 우리 id(Seoul.*)로는 결과가 안 나오고, 출발·도착역과 시각만 제3자에게 나간다.
    // 비워두면 역 패널의 검색 버튼이 비활성으로 남는다.
    searchUrl: '',

    // How long the cinema mode watches one train before hopping to the next
    cinemaDuration: 30000,

    // 시네마 모드에서 고를 수 있는 전환 주기. cinemaDuration 이 이 안에 있어야
    // 켤 때 어느 버튼이 선택된 상태인지 표시할 수 있다.
    cinemaDurations: [10000, 30000, 60000, 120000],

    // Timestamp when the static data was last updated
    lastStaticUpdate: '2026-09-02 17:30:00',

    // String to show in an Mapbox's AttributionControl
    customAttribution: '<a href="https://github.com/nagix/mini-tokyo-3d">© Akihiko Kusanagi</a>, <a href="https://data.seoul.go.kr">서울교통공사 열차시간표</a>, © OpenStreetMap contributors',

    // Copyright string
    copyright: '© 2019-2026 Akihiko Kusanagi',

    // Share URL
    shareUrl: 'https://metro.kgenots.com/map',

    // Supported events
    events: [
        'boxzoomcancel',
        'boxzoomend',
        'boxzoomstart',
        'click',
        'contextmenu',
        'dblclick',
        'drag',
        'dragend',
        'dragstart',
        'error',
        'load',
        'mousedown',
        'mousemove',
        'mouseout',
        'mouseover',
        'mouseup',
        'move',
        'moveend',
        'movestart',
        'pitch',
        'pitchend',
        'pitchstart',
        'resize',
        'rotate',
        'rotateend',
        'rotatestart',
        'touchcancel',
        'touchend',
        'touchmove',
        'touchstart',
        'wheel',
        'zoom',
        'zoomend',
        'zoomstart'
    ],

    // Supported languages
    langs: ['de', 'en', 'es', 'fr', 'ja', 'ko', 'ne', 'pt-BR', 'th', 'zh-Hans', 'zh-Hant']

};

export default configs;
